export default __webpack_public_path__ + "static/media/notfound.9aa569fd.jpg";